export class UserServiceRightInput {
  public profilsAssocies?: number[];
  public roleId?: number;
  public roleNonEcrasableParProfil?: boolean;
  public herResponsableService?: boolean;
  public herResponsableClassement?: boolean;
  public herResponsableDistribution?: boolean;
  public herValidationDistribution?: boolean;
  public herAccesDocumentConfidentiel?: boolean;
  public herSupprimerDocument?: boolean;
  public herRepondreALaPlaceDe?: boolean;
  public herRefuserCreationDocumentEntrant?: boolean;
  public herRefuserCreationDocumentSortant?: boolean;
  public herRefuserModification?: boolean;
  public herInterdireRepondreDocument?: boolean;
  public herRefuserAjoutDistribution?: boolean;
  public herRefuserAjoutFichier?: boolean;
  public herRefuserSuppressionFichier?: boolean;
  public herRefuserAjoutVersionFichier?: boolean;
  public herRefuserVisualisationVersionFichier?: boolean;
  public herRefuserModificationFichier?: boolean;
  public herRefuserVisualisationFichier?: boolean;
  public herCacherStatutMultiple?: boolean;
  public herCacherFichier?: boolean;
  public herRefuserMauvaisRoutage?: boolean;
  public herAccesMauvaisRoutage?: boolean;
  public herAccesRetourCourrier?: boolean;
  public herAccesStatistique?: boolean;
  public validationEtapes?: number[] = [];
  public validationDistribution?: boolean;
  // public responsableService?: boolean;
  // public responsableClassement?: boolean;
  // public responsableDistribution?: boolean;
  // public validationDistribution?: boolean;
  // public AccesDocumentConfidentiels?: boolean;
  // public supprimerDocument?: boolean;
  // public repondreALaPlaceDe?: boolean;
  // public refuserCreationDocumentEntrant?: boolean;
  // public refuserCreationDocumentSortant?: boolean;
  // public refuserModification?: boolean;
  // public interdireRepondreDocument?: boolean;
  // public refuserAjoutDistribution?: boolean;
  // public refuserAjoutFichier?: boolean;
  // public refuserSuppressionFichier?: boolean;
  // public refuserAjoutVersionFichier?: boolean;
  // public RefuserVisualisationVersionFichiers?: boolean;
  // public refuserModificationFichier?: boolean;
  // public refuserVisualisationFichier?: boolean;
  // public cacherStatutMultiples?: boolean;
  // public cacherFichiers?: boolean;
  // public refuserMauvaisRoutage?: boolean;
  // public accesMauvaisRoutage?: boolean;
  // public AccesRetourCourriers?: boolean;
  // public AccesStatistiques?: boolean;

  constructor(data?) {
    Object.assign(this, data);
  }
}
